import { useMutation, useQueryClient } from '@tanstack/react-query'
import { meetingKeys } from '@/entities/meeting'
import { apiPutVoid } from '@/shared/api'
import { toast } from '@/shared/ui/toast'

// Замок звонка. Право — у любого участника-сотрудника (проверяет бэк), поэтому
// UI не гейтит кнопку ролью: 403 прилетит только постороннему.
export function useLockMeeting(meetingId: string) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (locked: boolean) => apiPutVoid(`/meetings/${meetingId}/lock`, { locked }),
    onSuccess: (_data, locked) => {
      toast.success(locked ? 'Звонок закрыт — входящие ждут допуска' : 'Звонок открыт')
      void qc.invalidateQueries({ queryKey: meetingKeys.detail(meetingId) })
      void qc.invalidateQueries({ queryKey: meetingKeys.lists() })
    },
    onError: () => toast.error('Не удалось переключить замок'),
  })
}
